<div class="modal fade callLogModal" tabindex="-1" data-backdrop="false" role="dialog" aria-labelledby="myLargeModalLabel"
     id="modalPopUp">
  <div id="call-log-modal-dialogue" class="modal-dialog" style="width: auto">
    <div class="modal-content" *ngIf="showCallLogModal">
      <div class="modal-header">
        <h4 class="modal-title" translate>
          Log.call
          <span class="pointer-cursor float-right" (click)="closeModalConfirmation()">
                <i class="fa fa-times" aria-hidden="true"></i>
          </span>
        </h4>
      </div>
      <div class="modal-body">
        <div class="modal-container">
            <ng-container *access="['UseCallTemplates.readaccess']">
                <div class="custom-tag-left-side-container" *ngIf="showCallNoteTemplateOption && customTagsList && customTagsList.length">
                    <div class="tag-header">
                        <div class="vertical-line"></div>
                        <div class="tag-header-text">Tags</div>
                    </div>
                    <div class="tag-list-container">
                        <div *ngIf="customTagForm && customTagsList.length" [formGroup]="customTagForm">
                            <ng-container *ngFor="let tag of customTagsList">
                                <div *ngIf="tag.fieldType === 'dropdown'" style="margin-bottom: 16px;">
                                    <label [class]="customTagForm.controls[tag.name].disabled ? '' : 'required_field'"
                                           translate>{{ tag.name }}</label>
                                    <select style="width: 100%; margin-bottom: 0px;" [formControlName]="tag.name"
                                            [disabled]="customTagForm.controls[tag.name].disabled"
                                            (blur)="replaceCustomTags('{'+tag.name+'}')">
                                        <option value="">-- Please select --</option>
                                        <option *ngFor="let value of tag.options" [value]="value"
                                                translate>{{ value }}
                                        </option>
                                    </select>
                                </div>
                                <div *ngIf="tag.fieldType === 'input'" style="margin-bottom: 16px;">
                                    <label
                                        [class]="customTagForm.controls[tag.name].disabled ? 'control-label' : 'control-label required_field'">{{ tag.name }}</label>
                                    <input type="text" [formControlName]="tag.name" class="input-tag-type"
                                           [disabled]="customTagForm.controls[tag.name].disabled"
                                           (blur)="replaceCustomTags('{'+tag.name+'}')"/>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </ng-container>
          <div class="log-container">
            <ng-container *ngIf="showCallNoteTemplateOption">
              <div class="template-wrapper call-note-template-wrapper">
                <div class="email-search-bar-container" *ngIf="showTemplateList">
                  <app-use-template #useTemplate [screen]="'call_note_template'" [screenLabel]="'Call note template'"
                                      [showAddNewTemplate]="showAddNewTemplate"
                                      (selectedItem)="setTemplateDetails($event)"
                                      (cancelEvent)="cancelTemplate()"
                                      [openDropDown]=showTemplateList>
                  </app-use-template>
                </div>
              </div>
            </ng-container>
            <ng-container>
              <form *ngIf="callForm" [formGroup]="callForm">
                  <div class="job-complete" *ngIf="callActivityShow">
                      <label class="checkbox-button margin-btm0" for="callComplete">
                          <input class="checkbox-button__input" type="checkbox" id="callComplete"
                                 [checked]="completed" (change)="completeActivity($event)"/>
                          <span class="checkbox-button__control complete-check"></span>
                          <span class="checkbox-button__label" translate><i class="fa fa-phone margin-r5"
                                                                            aria-hidden="true"></i>
                      <span translate>activity.call.today</span></span>
                      </label>
                  </div>
                  <ng-container *access="['UseCallTemplates.readaccess']">
                      <div class="template-recommendation-bar" *ngIf="showCallNoteTemplateOption && showRecommendation">
                          <div class="dis-flex align-items-center" style="gap: 6px;">
                              <i class="fa-solid fa-book" style="color: #505B65"></i>
                              <span>It's recommended that you use the {{ selectedCallNoteTemplate.templateName || (selectedCallNoteTemplate['template'] && selectedCallNoteTemplate['template']['name']) }}</span>
                              <a class="ml-auto pointer-cursor" (click)="setTemplateDetails(selectedCallNoteTemplate)">Use
                                  this template</a>
                          </div>
                      </div>
                  </ng-container>
                <select  class="full-width-select2 select-blk activity-selected" placeholder="To"
                         formControlName="contactTelephoneId">
                  <option hidden value="" disabled selected>To</option>
                  <option  *ngIf="isContactNotFound" class="no-contact-found" disabled> <span>No matched found</span> </option>
                  <ng-container *ngFor="let contact of customerCallDetails">
                    <optgroup class="activity-option-color" label="{{contact?.contactName}}">
                      <option *ngFor="let details of contact?.contacts" value="{{details?.id}}">
                        {{details?.contactNumber}}</option>
                    </optgroup>
                  </ng-container>
                </select>
                <select class="full-width-select2 select-blk activity-selected" formControlName="callType">
                  <option hidden value="" disabled selected>Inbound/outbound call</option>
                  <option  class = "activity-option-color" *ngFor="let type of callType" [value]="type?.id">
                    {{type?.value}}</option>
                </select>
                <!--<textarea id="email-template-message" style="height: 400px;" rows="8" cols="70"
                          class="controls textareatest  tiny-mce-single-line-input-wrapper"
                          [ngStyle]="{'height': callActivityShow ? '240px' : '304px' }"
                          formControlName="note">
                  </textarea>-->
                  <div class="restrict-select-tag">
                      <quill-editor-custom [tagsList]="usersList" [form]="callForm" [screen]="screen" (contentChanged)="onContentChange($event)"
                                           [lableName]="'note'"></quill-editor-custom>
                  </div>

              </form>
            </ng-container>
            <ng-container *access="['UseCallFields.readaccess']">
              <div class="custom-fields-section" *ngIf="showCallCustomFields && customFieldForm && customFields && customFields.length" [formGroup]="customFieldForm">
                  <ng-container *ngFor="let cf of customFields">
                      <ng-container *ngIf="isFieldsValid(cf.value)">
                          <div class="custom-field-input-box">
                              <label class="control-label required_field">{{cf.key}}</label>
                              <select type="text" [formControlName]="cf.key" class="input-tag-type" >
                                  <option value="" disabled>-- Please select --</option>
                                  <option *ngFor="let value of cf.value" [ngValue]="value" [hidden]="value.archived == 1" >{{value.description}}</option>
                              </select>
                          </div>
                      </ng-container>
                  </ng-container>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <!-- Footer -->
      <div class="modal-footer" [ngClass]="{'attachments-over':modalBack == true}">
        <div class="row-fluid dis-flex">
          <div class="dis-flex align-items-center" *ngIf="showCallNoteTemplateOption">
            <span style="padding: 4px; cursor: pointer" (click)="showTemplateOptions()" [ngClass]="{'active-icon':showTemplateList == true}" *access="['UseCallTemplates.readaccess']">
              <i class="fa-regular fa-folder-open"></i>
            </span>
          </div>
          <div class="element-alignment-center ml-auto">
            <span class="activity-left">
              <div class="schedule-check">
                <label class="checkbox-button checkbox-text-center" for="completeScheduleActivity">
                  <input class="checkbox-button__input" type="checkbox" id="completeScheduleActivity"
                         [checked]="scheduled" (change)="isScheduledActivity($event)" />
                  <span class="checkbox-button__control"></span>
                  <span class="checkbox-button__label" translate="">Schedule.new.activity</span>
                </label>
              </div>
            </span>
            <button class="btn disgard-button activity-modal-discard" (click)="closeModalConfirmation()" translate>
              Discard
            </button>
            <button *ngIf="callForm" class="btn btn-primary" [disabled]="!callForm.valid || saveDisabled || (customFieldForm && !customFieldForm.valid && isCallCustomFieldEnabled && showCallCustomFields ) || (!customTagForm.disabled && !customTagForm.valid)"
                    (click)="saveCall()" translate>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
